import React, { useContext, useMemo } from 'react';
import { VenueAnalysisAggregatedLiquidityItem } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import AppContext from 'app/AppContext';
import { Tooltip } from '@instinet-analytics/core-lib';

export function OrderFillsCapsuleContentValues({
    data,
}: {
    data: VenueAnalysisAggregatedLiquidityItem[];
}) {
    const rows = useMemo(
        () => data.map((i) => <Row item={i} key={i.liquidity.index} />),
        [data]
    );

    return <div className="OrderLiquidityCapsuleContentValues">{rows}</div>;
}

function Row(props: { item: VenueAnalysisAggregatedLiquidityItem }) {
    const {
        item: {
            percent,
            liquidity: { name },
        },
    } = props;
    const { numberFormat } = useContext(AppContext);
    const percentText = `${numberFormat.n0(percent)}%`;

    return (
        <div className={`liquidity-row liquidity-${name}`}>
            <div className="label">
                <Tooltip text={`${name} (${percentText})`}>{name}</Tooltip>
            </div>
            <div className="value">{percentText}</div>
        </div>
    );
}
